import React from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import DataDisplay, {
  useResponsiveDataDisplayVariant,
} from '@sharedCR/coreDesignSystem/DataDisplay';
import TooltipWrapper from 'app/shared/components/common/TooltipWrapper';
import { WithLoadingPropTypes } from 'hocs/withLoading';

import useModifiedFieldPendingChangeAuthors from 'hooks/useModifiedFieldPendingChangeAuthors';

import {
  selectChattelDetails,
  selectIsChattelLoanFromPropertyAndLoanSummary,
  selectIsUnsecuredFromPropertyAndLoanSummary,
  selectLoanAndLockInfoMetrics,
  selectPropertyAndLoanSummarySubjectPropertyData,
} from 'store/loanApplications/selectors';

import { getMetricCardsConfig } from './MetricCards.config';
import { getMetricCardsWrapperStyles, metricCardStyles } from './MetricCards.styles';
import { getPendingChangeSourcesAuthors } from './MetricCards.utils';

const MetricCards = ({ isLoading = false }) => {
  const metrics = useSelector(selectLoanAndLockInfoMetrics);
  const isUnsecured = useSelector(selectIsUnsecuredFromPropertyAndLoanSummary);
  const isChattel = useSelector(selectIsChattelLoanFromPropertyAndLoanSummary);
  const subjectPropertyData = useSelector(selectPropertyAndLoanSummarySubjectPropertyData);
  const chattelDetails = useSelector(selectChattelDetails);
  const getModifiedFieldAuthors = useModifiedFieldPendingChangeAuthors();

  const dataDisplayVariant = useResponsiveDataDisplayVariant();

  const metricCardsConfig = getMetricCardsConfig(metrics, {
    isUnsecured,
    isChattel,
    subjectPropertyData,
    chattelDetails,
  });

  return (
    <Box sx={getMetricCardsWrapperStyles(metricCardsConfig.length)}>
      {metricCardsConfig.map(
        ({
          name,
          value,
          icon,
          iconColor,
          changeKind,
          pendingChangeSources,
          withInfoIcon,
          hoverContent,
          customTooltipStyles,
        }) => {
          const dataDisplay = (
            <Box sx={metricCardStyles}>
              <DataDisplay
                changeKind={changeKind}
                icon={icon}
                iconColor={iconColor}
                isAdditionalIcon={withInfoIcon}
                isLoading={isLoading}
                pendingChangeAuthors={getPendingChangeSourcesAuthors(
                  getModifiedFieldAuthors,
                  pendingChangeSources,
                )}
                title={name}
                value={value}
                variant={dataDisplayVariant}
              />
            </Box>
          );

          return hoverContent ? (
            <TooltipWrapper
              disableInteractive={false}
              key={name}
              title={hoverContent}
              tooltipSx={customTooltipStyles}
            >
              {dataDisplay}
            </TooltipWrapper>
          ) : (
            <React.Fragment key={name}>{dataDisplay}</React.Fragment>
          );
        },
      )}
    </Box>
  );
};

MetricCards.propTypes = {
  ...WithLoadingPropTypes,
};

export default MetricCards;
